module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAiCAYAAABFlhkzAAAA/0lEQVRIie2WO4oCQRRFTxcdikzoJ5bZgskkIkIbugVdxMDkMovQFTQYzoCYdeISGoz9hKLmyoMnVFQ2VhkIdeFF9fqeutXJTfI8B+gAv0AfqOOnE7ACvoFNCnwCa+DD0/guueAI6AFdA0zV/B9oAYnntNRLPKdGn0U0BvYBEuzVSzQw1puHMLchopqpsFwAV8cUro+rAB4pcZ2nFQy+fOghEkRABERABERABLwXIAN2OtkrAHOgqTN/BcCWs0k8C5gAB2BrNbeHSrUN1zW6q9396U4VNXTnYrRqi2bWgY/a1j9aSoIfrdrDwP30KN6SoJQeDyyAcwBj8RCvLlDeABQfLp7DUWbRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/bind1 (1).png
// module id = DS/R
// module chunks = 5